export const ACCESS_TOKEN = "access_token";
const APP_NAME = "User Profile";
export const CAPITALIZED_APP =
  APP_NAME[0].toUpperCase() + APP_NAME.slice(1).toLowerCase();
